document.querySelectorAll(".steps-section").forEach(section => {

  const track = section.querySelector(".content");
  const slides = section.querySelectorAll(".step-content");
  const tabs = section.querySelectorAll(".step");
  const carousel = section.querySelector(".steps-carousel");
  const prev = carousel ? carousel.querySelector(".step-nav--prev") : null;
  const next = carousel ? carousel.querySelector(".step-nav--next") : null;
  if (!track || !slides.length) return;

  let dragged = false;

  function activeIndex() {
    const center = track.scrollLeft + track.clientWidth / 2;
    let best = 0, bd = Infinity;
    slides.forEach((s, i) => {
      const sc = s.offsetLeft + s.offsetWidth / 2;
      const d = Math.abs(sc - center);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }

  function sync() {
    const idx = activeIndex();
    tabs.forEach((t, i) => t.classList.toggle("selected", i === idx));
    slides.forEach((s, i) => s.classList.toggle("selected", i === idx));
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }

  function goTo(i) {
    const s = slides[i];
    if (!s) return;
    const left = s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2;
    track.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
  }

  tabs.forEach((t, i) => t.addEventListener("click", (e) => { e.preventDefault(); goTo(i); }));
  if (prev) prev.addEventListener("click", () => goTo(Math.max(0, activeIndex() - 1)));
  if (next) next.addEventListener("click", () => goTo(Math.min(slides.length - 1, activeIndex() + 1)));

  let raf = 0;
  track.addEventListener("scroll", () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(sync);
  }, { passive: true });
  window.addEventListener("resize", sync);

  // drag-to-scroll (mouse + touch via Pointer Events)
  let down = false, startX = 0, startScroll = 0;
  track.addEventListener("pointerdown", (e) => {
    down = true; dragged = false;
    startX = e.clientX; startScroll = track.scrollLeft;
    track.classList.add("is-dragging");
    try { track.setPointerCapture(e.pointerId); } catch (_) {}
  });
  track.addEventListener("pointermove", (e) => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 5) dragged = true;
    track.scrollLeft = startScroll - dx;
  });
  const end = (e) => {
    if (!down) return;
    down = false;
    track.classList.remove("is-dragging");
    try { track.releasePointerCapture(e.pointerId); } catch (_) {}
    if (dragged) goTo(activeIndex()); // snap to nearest slide
    else sync();
  };
  track.addEventListener("pointerup", end);
  track.addEventListener("pointercancel", end);
  // a real drag must not trigger clicks inside the card
  track.addEventListener("click", (e) => {
    if (dragged) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  // keyboard arrows when carousel focused
  track.setAttribute("tabindex", "0");
  track.addEventListener("keydown", (e) => {
    if (e.key === "ArrowRight") { e.preventDefault(); goTo(Math.min(slides.length - 1, activeIndex() + 1)); }
    if (e.key === "ArrowLeft")  { e.preventDefault(); goTo(Math.max(0, activeIndex() - 1)); }
  });

  sync();
  setTimeout(sync, 300);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
});
